<template>
  <div>
    <div class="proDiv" :class="{[`device-${getPlatform()}`]:true}">
      <div class="node-start">
        <img src="@/assets/img_start.png" alt="">
        <img src="@/assets/jiantou2.png" class="xiaojiantou" alt="">
      </div>
      <div class="selectButton autoOrByhands">
        <div style="display: flex" class="upload-data-wrapper">
          <!--数据授权-->
            <SaMemoryTooltip style="margin-right: 8px"  ref="saUploadTooltipRef" :open="processGraphic?.graphicItemMap?.['data_authorize']?.nodeStatus==1&&processGraphic?.graphicItemMap?.['upload']?.nodeStatus==3&&type!='data_authorize'&&['upload','data_authorize'].includes(currentProcessCode)"  :identity="`showUploadTooltipShow-authorize-${this.programId}`" :disable="getPlatform()=='mobile'">
              <template v-slot:tooltip >
                请完成数据授权
              </template>
            <div :class="{
              selected: currentProcessCode === processGraphic?.graphicItemMap?.data_authorize?.code,
              disabled: !['upload','data_authorize'].includes(currentProcessCode)
            }"
                 class="ability-item" @click="chooseType('data_authorize')"
                 v-if="processGraphic?.graphicItemMap?.data_authorize">
              {{ processGraphic?.graphicItemMap?.data_authorize?.name }}

              <i
                class="iconfont icon-icon_chulizhong icon-processing"
                v-if="processGraphic?.graphicItemMap?.['data_authorize']?.nodeStatus==2"></i>
              <i
              class="iconfont icon-icon_succeed icon-finished"
              v-if="processGraphic?.graphicItemMap?.['data_authorize']?.nodeStatus==3"></i>
            </div>
            </SaMemoryTooltip>
          <!--离线导入-->
          <sa-memory-tooltip ref="saMemoryTooltipRef" :open="(processGraphic?.graphicItemMap?.['data_authorize']!=null&&(processGraphic?.graphicItemMap?.['data_authorize']?.nodeStatus==2||processGraphic?.graphicItemMap?.['data_authorize']?.nodeStatus==3))&&processGraphic?.graphicItemMap?.['upload']?.nodeStatus==1"  :identity="`showUploadTooltipShow-${this.programId}`" :disable="getPlatform()=='mobile'">
            <template v-slot:tooltip >
              请完成数据上传
            </template>
            <div :class="{
              selected: currentProcessCode === processGraphic?.graphicItemMap?.upload?.code,
              disabled: !['upload','data_authorize'].includes(currentProcessCode)
            }"
                 class="ability-item" @click="chooseType('upload')"
                 v-if="processGraphic?.graphicItemMap?.upload">
              {{ processGraphic?.graphicItemMap?.upload?.name }}

              <i
                class="iconfont icon-icon_chulizhong icon-processing"
                v-if="processGraphic?.graphicItemMap?.['upload']?.nodeStatus==2"></i>
              <i
                class="iconfont icon-icon_succeed icon-finished"
                v-if="processGraphic?.graphicItemMap?.['upload']?.nodeStatus==3"></i>

            </div>
          </sa-memory-tooltip>
          <!--/离线导入-->
          <!--手动补充数据-->
          <el-tooltip
            :disabled="processGraphic?.graphicItemMap?.start?.finish==false"
            class="box-item"
            effect="dark"
            content="当前无法打开，报告生成后可在【数据分析工具】中查看或编辑"
            placement="top-start"
          >
            <div class="byHands ability-item" v-if="withHands"
                 :class="state!==1?'disabled':type==2?'selected':''"
                 @click="chooseType(2)">上传数据 <i v-if="handsFinish"
                                                    class="iconfont icon-icon_succeed"></i>
            </div>
          </el-tooltip>
        </div>
      </div>
      <!-- <img src="@/assets/jiantou1.png" alt="" v-if="withHands"> -->
      <img src="@/assets/jiantou2.png" class="xiaojiantou" alt="">
      <div class="ability-item"
           :class="{disabled:currentProcessCode!=processGraphic?.graphicItemMap?.analyze?.code,
            selected:currentProcessCode==processGraphic?.graphicItemMap?.analyze?.code
      }">
        {{ processGraphic?.graphicItemMap?.analyze?.name }}
      </div>
      <img src="@/assets/jiantou2.png" class="xiaojiantou" alt="">
      <div class="ability-item" :class="state!==3?'disabled':'selected'">
        {{ processGraphic?.graphicItemMap?.generate?.name }}
      </div>
      <div class="node-end">
        <img src="@/assets/jiantou2.png" class="xiaojiantou" alt="">
        <img src="@/assets/img_complete.png" alt="">
      </div>
    </div>
  </div>
</template>
<script>
import { getPlatform } from "@/utils/device";
import SaMemoryTooltip from "@/pages/components/SaMemoryTooltip.vue";

export default {
  name: "DaliProgressV4",
  components: {SaMemoryTooltip},
  props: {
    programId:{
      type: String
    },
    processGraphic: {
      type: Object,
      default: () => ({}),
      required: false
    },
    currentProcessCode: String
  },
  computed: {
    abilities () {
      return this.processGraphic?.graphicItemMap ? Object.keys(this.processGraphic?.graphicItemMap) : []
    },
    currentItemCode () {
      return this.processGraphic?.currentItemCode

    }
  },
  data () {
    return {
      toolTipVisible:true,
      state: 1,
      withHands: false,
      autoFinish: false,
      handsFinish: false,
      isOfflineUpload: false,
      trans: 0,
      type: 'data_authorize'
    }
  },
  watch: {
    processGraphic: {
      async handler () {
        await this.getState()
      }
    }
  },
  methods: {
    getPlatform,
    userAgent(){
      return navigator.userAgent
    },
    async getState () {
      const stateList = ["data_authorize", "analyze", "generate"]

      this.autoFinish = this.processGraphic?.graphicItemMap?.['data_authorize']?.finish
      if (this.autoFinish) {
        this.$emit('changeFinish', this.autoFinish)
      }

      const keyArr = Object.keys(this.processGraphic?.graphicItemMap)
      this.trans++
      /*如果是离线上传*/
      if (this.trans === 1) {
        if (keyArr.includes('upload')) {
          this.isOfflineUpload = true
          this.$emit('choose', { types: 1, isOffline: this.isOfflineUpload })
        } else {
          this.isOfflineUpload = false
          this.$emit('choose', { types: 1, isOffline: this.isOfflineUpload })
        }
      }
      /*是否有手动补充数据*/
      let handIndex = keyArr.findIndex(i => i == 'data_manual_upload')
      if (handIndex > -1) {
        this.withHands = true
        this.handsFinish = this.processGraphic?.graphicItemMap['data_manual_upload'] ? this.processGraphic?.graphicItemMap['data_manual_upload'].finish : false
        if (this.handsFinish) {
          this.$emit('changeFinish2', this.handsFinish)
        }
      }
      if (this.processGraphic?.currentItemCode == 'data_authorize' || this.processGraphic?.currentItemCode == 'data_manual_upload' || this.processGraphic?.currentItemCode == 'upload') {
        this.state = 1
      } else {
        let index = stateList.findIndex(i => i == this.processGraphic?.currentItemCode) + 1
        this.state = index
      }
      /*如果是完成报告，则清空轮询获取状态的接口*/
      if (this.processGraphic?.currentItemCode === 'generate') {
        this.$emit('finish')
      }
      this.$emit('changeState', this.state)
    },
    chooseType (e) {
      if (['upload'].includes(e)){
        this.$refs['saMemoryTooltipRef'].close()
      }

      if (['upload','data_authorize'].includes(this.currentProcessCode)){
        this.type = e
        this.$emit('chooseAbility', e)
      }

    },
  },
  mounted () {
    this.state = 1
  }
}

// const emits = defineEmits(["choose", "changeState", 'changeFinish', "changeFinish2", 'transformData']);
//
// let checkTimer = null
//
//
//
// // 自动采集或者手动补充   1自动2手动
</script>
<style scoped lang="stylus">
.autoOrByhands {
}
.ability-item {
  margin 0;
  width 126px;
  text-align: center;
  line-height: 2.5;
  height: 36px;
  font-size: 14px;
  background: #F4F6F8;
  border-radius: 4px 4px 4px 4px;
  color: #1D2129;
  cursor: pointer;
}
.upload-data-wrapper{
  .ability-item{
    margin-right:8px;
  }
  .ability-item:last-child{
    margin 0;
  }
}

.ability-item.selected {
  background: #E7EEFF;
  color: #165DFF;
  font-weight: 600;
}
.ability-item.disabled {
  background: #F4F6F8;
  cursor: not-allowed;
  color: #A4A6A9;
}
.proDiv {
  margin: 0 0 8px 0;
  display: flex;
  align-items: center;
  justify-content center
  img {
    width: 40px;
    height: 40px;
  }
  > img {
    margin: 0 12px;
  }
  > img + img {
    margin-left: 0px
  }
  img.xiaojiantou {
    width: 32px;
    height: 12px;
    margin: 0 16px;
  }
  .selectButton {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    i {

      margin-left: 4px;
      font-size: 14px;
    }
    i.icon-processing{
      color: #165DFF;
    }
    i.icon-finished{
      color: #10CC99;
    }
    > div {
    }
    div.selected {
      background: #E7EEFF;
      color: #165DFF;
      font-weight: 600;
    }
    div.disabled {
      background: #F4F6F8;
      cursor: not-allowed;
      color: #A4A6A9;
    }
  }
}
.device-mobile {
  .proDiv{
    display flex;
    justify-content space-between
  }
  .node-start {
    display none;
  }

  .ability-item, .box-item {
    display flex;
    align-items center
    justify-content center
    font-size 14px;
    line-height 1
    height .64rem
    padding 8px .3rem
    margin-bottom 0px;
  }
  .ability-item:first-child{
    margin-bottom 5px
  }
  .upload-data-wrapper {
    flex-direction column
    .box-item {
      margin-bottom 8px
    }
    .box-item:last-child {
      margin-bottom 0
    }
  }
  img.xiaojiantou {
    width: 22px;
    height: 9.5px;
    margin 0
  }
  .node-end {
    display none;
  }
}

</style>
